import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
declare var videojs:any;
import './quality-switch-plugin';

@Directive({
  selector: '[video-js]'
})
export class VideoJsDirective {
  @Input('src') src:string;
  constructor(
    private elRef:ElementRef,
    private renderer:Renderer2,
    // private zone:NgZone,
  ) { 
  }
  ngAfterViewInit () {
    const video:HTMLVideoElement = this.elRef.nativeElement;
    this.renderer.setAttribute(video, 'class', 'video-js vjs-16-9 vjs-big-play-centered vjs-default-skin');
    // this.zone.runOutsideAngular(()=>{
      const player = videojs(video);
      const src = this.src || player.currentSrc();
      player.src({
        src,
        type:'application/x-mpegURL'
      });  
      player.one('loadedmetadata', (e)=>{
        player.qualitySwitch();      
        player.controlBar.addChild('QualitySelector', undefined, player.controlBar.children_.length - 1);
      })
    // })
  }
  ngOnDestroy () {
    videojs(this.elRef.nativeElement).dispose();    
  }
  normalizeRelativeUrl (relativeUrl, root) {
    if (relativeUrl.match(/https?:\/\//)) return relativeUrl;
    var to = root.lastIndexOf('/');
    to = to == -1 ? root.length : to + 1;
    root = root.substring(0, to);    
    return root + relativeUrl.replace(/^\//, '');
  }

}
